import { FC } from 'react';

import { Input } from '../../../../components/ui/Input';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../../../../components/ui/Select';
import { OfferProperty } from '../../../../types';

interface Props {
    columnProperty: OfferProperty;
    editableProperty?: OfferProperty;
    propertySet: Record<string, string>;
    inputId: string;
    ariaLabel: string;
    onChange: (propertySet: Record<string, string>) => void;
}

export const BulkOfferPropertyField: FC<Props> = ({
    columnProperty,
    editableProperty,
    propertySet,
    inputId,
    ariaLabel,
    onChange,
}) => {
    if (!editableProperty) {
        return (
            <div
                className="flex h-9 items-center text-sm text-muted-foreground"
                data-testid={`offer-draft-property-${columnProperty.slug}`}
            >
                —
            </div>
        );
    }

    const propertyHint = editableProperty.hint?.trim();
    const selectedOptionHint =
        editableProperty.kind === 'collection'
            ? editableProperty.offer_property_options
                  .find(
                      (option) =>
                          option.slug === propertySet[columnProperty.slug],
                  )
                  ?.hint?.trim()
            : null;
    const displayedHint = selectedOptionHint || propertyHint;

    return (
        <div
            className="min-w-0 break-words"
            data-testid={`offer-draft-property-${columnProperty.slug}`}
        >
            {editableProperty.kind === 'collection' ? (
                <Select
                    value={propertySet[columnProperty.slug]}
                    onValueChange={(value) =>
                        onChange({
                            ...propertySet,
                            [columnProperty.slug]: value,
                        })
                    }
                >
                    <SelectTrigger
                        id={inputId}
                        className="h-9 min-w-0 text-sm"
                        aria-label={ariaLabel}
                    >
                        <SelectValue placeholder="Оберіть" />
                    </SelectTrigger>
                    <SelectContent>
                        {editableProperty.offer_property_options.map(
                            (option) => (
                                <SelectItem
                                    key={option.slug}
                                    value={option.slug}
                                >
                                    {option.name}
                                </SelectItem>
                            ),
                        )}
                    </SelectContent>
                </Select>
            ) : (
                <Input
                    id={inputId}
                    aria-label={ariaLabel}
                    type={
                        editableProperty.kind === 'number' ? 'number' : 'text'
                    }
                    maxLength={
                        editableProperty.kind === 'string' ? 120 : undefined
                    }
                    value={propertySet[columnProperty.slug] ?? ''}
                    onChange={(event) =>
                        onChange({
                            ...propertySet,
                            [columnProperty.slug]: event.target.value,
                        })
                    }
                    className="h-9 min-w-0 text-sm"
                    placeholder={editableProperty.name}
                />
            )}
            {displayedHint && (
                <p className="mt-1 text-xs leading-snug text-muted-foreground">
                    {displayedHint}
                </p>
            )}
        </div>
    );
};
